"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var url_1 = require("url");
var querystring_1 = require("querystring");
var events_1 = require("events");
var client_1 = require("rest-resource/dist/client");
var logger_1 = tslib_1.__importDefault(require("../logger"));
var axios_rate_limit_1 = tslib_1.__importDefault(require("axios-rate-limit"));
var lodash_1 = require("lodash");
var assert_1 = tslib_1.__importDefault(require("assert"));
function axiosRequestLogger(request) {
    return new Promise(function (resolve) {
        logger_1.default.info(request.method.toUpperCase() + " " + request.url);
        if (request.data) {
            logger_1.default.info("" + JSON.stringify(request.data, null, '    '));
        }
        resolve(request);
    });
}
exports.axiosRequestLogger = axiosRequestLogger;
var SigmaAPIClient = /** @class */ (function (_super) {
    tslib_1.__extends(SigmaAPIClient, _super);
    function SigmaAPIClient(baseURL, token, options) {
        var _this = _super.call(this, baseURL, token) || this;
        _this.concurrency = 10;
        _this.events = new events_1.EventEmitter();
        _this.axios = axios_rate_limit_1.default(_this.axios, { maxRequests: _this.concurrency, perMilliseconds: 1000 });
        _this.axios.interceptors.request.use(axiosRequestLogger);
        return _this;
    }
    SigmaAPIClient.prototype.setConcurrency = function (maxConnections) {
        this.axios.setMaxRPS(maxConnections);
    };
    SigmaAPIClient.prototype.negotiateContent = function (ResourceClass) {
        return function (response) {
            if (PagedContentNegotiator.isSigmaListResponse(response)) {
                return new PagedContentNegotiator(ResourceClass, response);
            }
            else {
                return new DefaultContentNegotiator(ResourceClass, response);
            }
        };
    };
    SigmaAPIClient.prototype.getTokenPayload = function () {
        return _super.prototype.getTokenPayload.call(this);
    };
    SigmaAPIClient.prototype.onError = function (exception) {
        // If it's a 400 or a 401, run onTokenExpired hook
        // @todo We may want to separate out 400s and 401s to differentiate reasons as to why renew failed
        if (exception.response && [400, 401].includes(exception.response.status)) {
            this.events.emit('token.expires');
            return exception;
        }
        throw exception;
    };
    return SigmaAPIClient;
}(client_1.JWTBearerClient));
exports.SigmaAPIClient = SigmaAPIClient;
var DefaultContentNegotiator = /** @class */ (function () {
    function DefaultContentNegotiator(ResourceClass, response) {
        this.resources = [];
        this.ResourceClass = ResourceClass;
        this.response = response;
        this.body = this.response.data;
        this.urlInfo = url_1.parse(response.config.url);
        if ('string' === typeof this.urlInfo.query) {
            this.query = querystring_1.parse(this.urlInfo.query) || {};
        }
        else {
            this.query = {};
        }
        this.parseResources();
    }
    DefaultContentNegotiator.prototype.parseResources = function () {
        var ResourceClass = this.ResourceClass;
        this.resources.push(new ResourceClass(this.body));
    };
    return DefaultContentNegotiator;
}());
exports.DefaultContentNegotiator = DefaultContentNegotiator;
var PagedContentNegotiator = /** @class */ (function (_super) {
    tslib_1.__extends(PagedContentNegotiator, _super);
    function PagedContentNegotiator(ResourceClass, response) {
        var _this = _super.call(this, ResourceClass, response) || this;
        assert_1.default(_this.body.results, 'Can\'t create PageResponse instance without "results" property in body');
        _this.count = Number(_this.body.count);
        _this.pages = Number(_this.body.page_count);
        _this.pageSize = Number(_this.body.page_size);
        _this.page = Number(_this.query.page) || 1;
        return _this;
    }
    PagedContentNegotiator.isSigmaListResponse = function (response) {
        return response.data && response.data.results;
    };
    PagedContentNegotiator.prototype.assertPageSize = function (page) {
        assert_1.default(page >= 1 && page <= this.pages, "Page size must be between 1 and " + this.pages + " (received " + page + ")");
    };
    PagedContentNegotiator.prototype.parseResources = function () {
        var ResourceClass = this.ResourceClass;
        for (var i = 0; i < this.body.results.length; i++) {
            this.resources.push(new ResourceClass(this.body.results[i]));
        }
    };
    PagedContentNegotiator.prototype.nextPage = function () {
        var ResourceClass = this.ResourceClass;
        var query = Object.assign({}, this.query, { page: this.page + 1 });
        this.assertPageSize(query.page);
        return ResourceClass.list({ query: query });
    };
    PagedContentNegotiator.prototype.prevPage = function () {
        var ResourceClass = this.ResourceClass;
        var query = Object.assign({}, this.query, { page: this.page - 1 });
        this.assertPageSize(query.page);
        return ResourceClass.list({ query: query });
    };
    PagedContentNegotiator.prototype.goToPage = function (pageNumber) {
        var ResourceClass = this.ResourceClass;
        var query = Object.assign({}, this.query, { page: pageNumber });
        this.assertPageSize(query.page);
        return ResourceClass.list({ query: query });
    };
    PagedContentNegotiator.prototype.otherPageNumbers = function () {
        var _this = this;
        return lodash_1.range(1, this.pages + 1, 1).filter(function (page) { return page != _this.page; });
    };
    return PagedContentNegotiator;
}(DefaultContentNegotiator));
exports.PagedContentNegotiator = PagedContentNegotiator;
/**
 * Creates an interceptor that will preemptively renew token in a client instance before further
 * API requests are sent
 * @param client
 * @param options
 */
function createTokenPrefetchInterceptor(client, options) {
    if (options === void 0) { options = {}; }
    // The amount of seconds before a token expires to attempt an auth renew request
    var prefetchSeconds = options.prefetchSeconds || 600;
    // Ignore paths -- any path listed here will not result in an auth renew request
    var ignorePaths = options.ignorePaths || ['/', '/auth', '/auth/renew'];
    // Calculate next renewal time based on current value of client.token
    var calculateNextRenewal = function () {
        var payload = client.getTokenPayload();
        if (!payload) {
            return new Date(-1);
        }
        return new Date((payload.exp - prefetchSeconds) * 1000);
    };
    // Next renewal Date instance
    var nextRenewal = calculateNextRenewal();
    // Is set to true when a request to /auth/renew is taking place
    // This is important because any number of requests may be sent off synchronously but
    // we only want the first one to fire off the request to /auth/renew -- the other requests
    // have to wait
    var isRenewing = false;
    // How many milliseconds to poll status of isRenewing for pending requests
    var renewingPollMs = options.pendingRenewalPollMilliseconds || 300;
    // Similar to above except just resolve the request anyways after n milliseconds
    var renewPollTimeoutMs = options.pendingRenewalPollTimeout || 5000;
    return function (request) {
        return new Promise(function (resolve, reject) {
            // Check if this path is included in ignorePaths
            if (ignorePaths.includes(request.url)) {
                // It is, ignore it
                resolve(request);
            }
            else if (isRenewing) {
                // A request to /auth/renew is still pending, wait n milliseconds and check isRenewing again
                // Once it's true, resolve the other requests
                // @todo We might want to change the pending requests tokens mid-flight at some point
                var timeoutMsRemaining_1 = renewPollTimeoutMs;
                var checkTimeoutID_1 = setInterval(function () {
                    if (!isRenewing || timeoutMsRemaining_1 < 1) {
                        // Previous request to /auth/renew is done so resolve the pending requests
                        resolve(request);
                        clearInterval(checkTimeoutID_1);
                    }
                    else {
                        timeoutMsRemaining_1 -= renewingPollMs;
                    }
                }, renewingPollMs);
            }
            else if (nextRenewal && new Date() > nextRenewal) {
                // Set isRenewing to true
                isRenewing = true;
                // Refresh token
                client
                    .post('/auth/renew', { token: client.token })
                    .then(function (result) {
                    if (result && result.status === 200) {
                        // Make sure we update the token in the client
                        client.token = result.data.token;
                        // Also set the next renewal check Date based on this new token
                        nextRenewal = calculateNextRenewal();
                        // Run onTokenRenew hook on client
                        client.events.emit('token.renews');
                    }
                    else {
                        logger_1.default.warn('Auth renew attempt unsuccessful');
                        //resolve(request)
                    }
                    // Resolve the request
                    resolve(request);
                })
                    .catch(function (e) {
                    // Delegate exception to client.onError
                    client.onError(e);
                    // Resolve requests anyways
                    resolve(request);
                })
                    .finally(function () {
                    isRenewing = false;
                });
            }
            else {
                // Just resolve the request anyways
                resolve(request);
            }
        });
    };
}
exports.createTokenPrefetchInterceptor = createTokenPrefetchInterceptor;
exports.globalClient = new SigmaAPIClient('/');
//# sourceMappingURL=client.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/client.js
// module id = 3fvT
// module chunks = 0